import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { combineLatest, merge, Observable } from 'rxjs';
import { AuthService } from '../../../../../../libs/feature/auth/src'
import { map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PaymentsAuthGuard implements CanActivate, CanLoad, CanActivateChild {
  constructor(private auth: AuthService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return (this.auth.isAuthenticated$.pipe(take(1)));
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.redirectIfUnauthenticated(state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.redirectIfUnauthenticated(state);
  }

  private redirectIfUnauthenticated(state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest(this.auth.isAuthenticated$, this.checkPaymentsRoles(), (first, second) => first && second).pipe(
      tap((loggedIn) => {
        if (!loggedIn) {
          this.auth.loginWithRedirect(state.url);
        }
      })
    );
  }

  private checkPaymentsRoles(): Observable<boolean> {
    return this.auth.roles$.pipe(map(value => 
      value.includes('MXP_USER') || value.includes('MXP_POWER_USER') || value.includes('MXP_POWER_ADMIN') || value.includes('MXP_STORE_ADMIN')));
  }
}